import { createSelector } from "reselect";
const authSelect = (state) => state.auth;

export const selectAuth = createSelector([authSelect], (auth) => auth);
export const selectAuthCurrent = createSelector(
  [authSelect],
  (auth) => auth.current
);

export const isLoggedIn = createSelector(
  [authSelect],
  (auth) => auth.isLoggedIn
);

export const selectUserNotifications = createSelector(
  [authSelect],
  (auth) => auth.notifications
);
